/** @format */

const template = `
<div class="messenger-inner" id="{{$ctrl.message.id}}">
  <ul class="messenger-language-selector">
    <li ng-repeat="lang in $ctrl.supportedLocales" ng-class="{active: $ctrl.selectedLocale == lang, invalid: $ctrl.noContent(lang)}"
      ><a href ng-click="$ctrl.selectLocale(lang)">{{lang}}</a></li
    >
  </ul>
  <div class="row messenger-title">
    <div class="col-6 col-sm-8 col-xl-9" data-cy="cur-sent-message-title">
      <span ng-if="$ctrl.message.localizedTitle[$ctrl.selectedLocale]">{{$ctrl.message.localizedTitle[$ctrl.selectedLocale]}}</span>
      <span ng-if="!$ctrl.message.localizedTitle[$ctrl.selectedLocale]" class="title-not-in-this-language" translate
        >SIS_COMPONENTS.MESSENGER.MESSAGE.TITLE_NOT_IN_THIS_LANGUAGE</span
      >
    </div>
    <div class="col-6 col-sm-4 col-xl-3 messenger-timestamp">{{$ctrl.message.messageTime|localDateTimeFormat}}</div>
  </div>
  <div class="row">
    <div class="col-6 messenger-recipient-title">
      <button
        type="button"
        class="link-button"
        data-cy-id="cur-message-recipient-href-{{$ctrl.message.id}}"
        data-cy="cur-message-recipient-hrefs"
        ng-click="$ctrl.recipientsVisible = !$ctrl.recipientsVisible">
        <span translate="SIS_COMPONENTS.MESSENGER.MESSAGE.RECIPIENTS" translate-value-count="{{$ctrl.message.recipientIds.length}}"></span>
        <sis-icon icon="chevron" [icon-class]="$ctrl.recipientsVisible ? 'cw-90' : null"></sis-icon>
      </button>
    </div>
    <div class="col-6 messenger-author"> {{ $ctrl.message.senderFullName }} {{ $ctrl.message.senderName| localizedString}} </div>
  </div>
  <div
    ng-if="$ctrl.recipientsVisible"
    data-cy-id="cur-message-recipient-list-{{$ctrl.message.id}}"
    data-cy="cur-message-recipient-lists"
    class="row messenger-recipients-list">
    <div class="col-12">
      <span ng-repeat="recipient in $ctrl.message.recipients track by recipient.id">
        {{recipient.fullNameReversed}} ({{recipient.studentNumber}}){{$last ? '' : ', ' }}
      </span>
    </div>
  </div>
  <div class="row messenger-message">
    <div class="col-12 message-comment">
      <div ng-if="$ctrl.message.localizedComment[$ctrl.selectedLocale]" data-cy="cur-message-content"
        ><sis-localized-markup-string-view
          [content]="$ctrl.message.localizedComment"
          [language]="$ctrl.selectedLocale"></sis-localized-markup-string-view
      ></div>
      <span ng-if="!$ctrl.message.localizedComment[$ctrl.selectedLocale]" class="message-not-in-this-language"
        ><span translate>SIS_COMPONENTS.MESSENGER.MESSAGE.MESSAGE_NOT_IN_THIS_LANGUAGE</span></span
      >
    </div>
  </div>
</div>
`;
export default template;
